import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useAddTemplate = function useAddTemplate() {
  return useMutation(function (params) {
    return servicesUtils.postService("/report_templates/create/", params);
  });
};
export default useAddTemplate;